// extracted by mini-css-extract-plugin
export default {"root":"StepProgress_root__EX1xG"};